<template>
  <div id="divCustomerPortalHome">
    <div class="dashboard-home mainArea top10">
      <div id="divBillingAndServicePoints" class="col-md-6" ref="billingAndServicePoints">
        <BillingSummary />
        <ServicePoints />
      </div>
      <div id="divAccountInformationAndUsage" class="col-md-6" ref="accountInformationAndUsage">
        <AccountInformation />
        <RecentUsage />
      </div>
      <div id="divBillingHeaderSummary" class="col-md-6" ref="billingHeaderSummary" v-if="!displayForDesktop">
        <BillingSummaryMobile />
      </div>
    
    </div>
  
    <div id="divEnergyEfficiencyTips" class="dashboard-home col-md-12"  ref="EnergyEfficiencyTips">
      <EnergyEfficiencyTips />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BillingSummaryMobile from '@/components/dashboardHome/BillingSummaryMobile';
import BillingSummary from '@/components/dashboardHome/BillingSummary';
import ServicePoints from '@/components/dashboardHome/ServicePoints';
import AccountInformation from '@/components/dashboardHome/AccountInformation';
import RecentUsage from '@/components/dashboardHome/RecentUsage';
import EnergyEfficiencyTips from '@/components/dashboardHome/EnergyEfficiencyTips';
export default {
  name: 'Home',
  components: {
    BillingSummaryMobile,
    BillingSummary,
    ServicePoints,
    AccountInformation,
    RecentUsage,
    EnergyEfficiencyTips
  },
  computed: {
    displayForDesktop() {
      return this.$store.getters.getIsDesktop;
    }
  }
}
</script>

<style scoped>
.col-md-6 {
  padding: 8px;
}      
.col-md-12 {
  padding: 8px;
}      
#divBillingHeaderSummary {
  padding-bottom: 3px;
}
</style>
